import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Mai%20Shiranui%20epic%20hero%20pose%20with%20dramatic%20fire%20effects%20surrounding%20her%20dynamic%20fighting%20stance%20traditional%20Japanese%20temple%20rooftop%20at%20sunset%20silhouette%20style%20with%20warm%20orange%20crimson%20and%20gold%20tones%20cinematic%20lighting%20anime%20art%20style%20high%20contrast%20dramatic%20composition%20with%20cherry%20blossom%20petals%20floating%20in%20the%20air&width=1600&height=900&seq=hero-mai-2026&orientation=landscape"
          alt="不知火舞"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-300/30 mb-8">
          <i className="ri-fire-line text-primary-400"></i>
          <span className="text-sm font-medium text-primary-200">拳皇档案馆 · 角色深度解析</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight mb-6">
          不知火舞
          <span className="block text-2xl md:text-3xl lg:text-4xl font-bold text-accent-300 mt-3">
            火焰中的女忍者
          </span>
        </h1>

        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto leading-relaxed mb-10">
          从饿狼传说到拳皇，跨越三十年的传奇女忍者。深度解析角色背景、技能体系、
          连招攻略与文化影响，助你全面掌握不知火舞的战斗精髓。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/character-background"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            探索角色背景
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/combo-guide"
            className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold text-sm border border-background-50/25 hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap"
          >
            查看连招攻略
            <i className="ri-sword-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-14 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-300 font-heading">30+</div>
            <div className="text-xs text-background-300 mt-1">年传奇历史</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-300 font-heading">50+</div>
            <div className="text-xs text-background-300 mt-1">技能招式</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-300 font-heading">20+</div>
            <div className="text-xs text-background-300 mt-1">跨界出演</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-300 font-heading">TOP 4</div>
            <div className="text-xs text-background-300 mt-1">SNK女角排行</div>
          </div>
        </div>
      </div>
    </section>
  );
}